import React, { Component } from 'react';
import { Modal, Button, Table, Form } from 'react-bootstrap';
import funciones from '../../middleware/funciones';
import config from '../../config';

class Example extends Component {

  constructor(props) {
    super(props);
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
    const yyyy = today.getFullYear();
    const todayFormat = yyyy + "-" + mm + "-" + dd;
    this.state = {
      show: false,
      prefijo: "",
      numero_documento: '',
      fecha_inicial: todayFormat,
      fecha_final: todayFormat,
      data: []
    }
  }
  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });

  componentDidMount=()=>{
    const {showfilter}= this.props;
    if(!showfilter)this.buscar();
  }

  buscar = () => {
    const currentCompany = sessionStorage.getItem('company');
    const clienteSelect = (this.props.cliente) ? this.props.cliente[0] : "";
    const estado = (this.props.estado) ? this.props.estado : "";
    const {showfilter}= this.props;

    //const {callback} = this.props;
    const busqueda = {
      cliente: clienteSelect.DOCUMENTO_CLIENTE,
      fecha_ini: (showfilter) ?  this.state.fecha_inicial: "",
      fecha_fin: (showfilter) ? this.state.fecha_final: "",
      prefijo: (showfilter) ? this.state.prefijo: "",
      numero: (showfilter) ? this.state.numero_documento: "",
      estado
    }
    const datasend = {
      method: 'POST',
      body: JSON.stringify(busqueda),
      headers: {
        'Content-Type': 'application/json',
        'empresa': currentCompany,
        'tipo': this.state.tipo,
      }
    };

    fetch(config.servBackEnd + '/invoice/searchInvoice', datasend).then(response => response.json())
      .then(datos => {
        const { data } = datos
        ////console.log(datos);
        if (datos.ok) {
          this.setState({ data })
        } else {
          this.setState({ data: [] })
        }
      });
  }

  selectFact = (e) => {
    const { callback } = this.props;
    this.setState({ show: false });
    callback(e);
  }

  createListado = () => {
    let fila = [];
    let column = [];
    const { data } = this.state;
    ////console.log(data);
    if (data.length !== 0) {
      data.forEach((element, index) => {
        column.push(<td key={'td' + index} onClick={() => this.selectFact(element)} >{element.TIPO_DOCUMENTO_CABECERA + "-" + element.NUMERO_FACTURA_CABECERA}</td>)
        if ((index + 1) % 6 === 0) {
          fila.push(<tr key={'tr' + index}>{column}</tr>);
          column = [];
        }

      });
    } else {
      column.push(<td key={'td1'} colSpan="6">Facturas no encontradas</td>)
    }

    fila.push(<tr key={'tr' + (parseInt(fila.length, 10) + 1)} >{column}</tr>);
    return fila;
  }

  render() {
    const clienteSelect = (this.props.cliente) ? this.props.cliente[0] : "";
    const {showfilter}= this.props;
    const { data } = this.state;
    const selectFact = this.selectFact;
    ////console.log(data);
    return (
      <div>
        <Button className="m-2" variant="primary" onClick={this.handleShow}>
          Seleccione Factura
      </Button>

        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>SELECCIONAR FACTURAS</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {showfilter &&
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th colSpan="4">Buscar Factura de {clienteSelect.NOMBRE_CLIENTE}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>TIPO DOCUMENTO</td>
                  <td><Form.Control type="text" onChange={e => this.setState({ prefijo: e.target.value.toUpperCase() })} value={this.state.prefijo} /></td>
                  <td>NUMERO DOCUMENTO</td>
                  <td><Form.Control type="number" min="1" onChange={e => this.setState({ numero_documento: e.target.value })} value={this.state.numero_documento} /></td>
                </tr>

                <tr>
                  <td>FECHA INICIO</td>
                  <td><Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value })} value={funciones.formatDate(this.state.fecha_inicial)} /></td>
                  <td>FECHA FIN</td>
                  <td><Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value })} value={funciones.formatDate(this.state.fecha_final)} /></td>
                </tr>
                <tr>
                  <td colSpan="4"><Button onClick={this.buscar} >Buscar</Button> </td>
                </tr>
              </tbody>
            </Table>}
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>DOCUMENTO</th>
                  <th>FECHA DOCUMENTO</th>
                  <th>FECHA VENCIMIENTO</th>
                  <th>DIAS VENCIMIENTO</th>
                  <th>TOTAL DOCUMENTO</th>
                  <th>PENDIENTE</th>
                </tr>
              </thead>
              <tbody>
                {/*this.createListado()*/}
                {data.map((element, i) => {
                  return (<tr key={i} onClick={() => selectFact(element)}>
                    <td>{element.TIPO_DOCUMENTO_CABECERA + "-" + element.NUMERO_FACTURA_CABECERA}</td>
                    <td>{element.FECHA_DOCUMENTO}</td>
                    <td>{element.FECHA_VENCIMIENTO_DOCUMENTO}</td>
                    <td>{element.DIAS_VENCIMIENTO}</td>
                    <td className="currSign">{Intl.NumberFormat('es-MX').format(element.TOTAL_VENTA)}</td>
                    <td className="currSign">{Intl.NumberFormat('es-MX').format(parseFloat(element.TOTAL_VENTA) - parseFloat(element.TOTAL_ABONADO))}</td>
                  </tr>);
                })}
              </tbody>

            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>Cancelar</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default Example;